import React, { Dispatch, FormEvent, SetStateAction } from 'react'
import { getAuthUser } from '../../../helpers'
import { updateRecord, UpdateRecordParams, toastSuccess } from '../../../api'
import { Record } from '../../../models'
import { RecordRefundForm } from './form'
import defineAbilityFor from './defineAbility'
import { InsufficientPermissions } from '../../common'

interface EditRecordRefundProps {
    record: Record
    setIsEditing: Dispatch<SetStateAction<boolean>>
    setRecord: Dispatch<SetStateAction<Record | undefined>>
}

export const EditRecordRefundForm = (props: EditRecordRefundProps) => {
    const { record, setIsEditing, setRecord } = props

    const ability = defineAbilityFor(getAuthUser())

    const handleSubmit = (e: FormEvent<HTMLFormElement>, inputs: UpdateRecordParams) => {
        e.preventDefault()

        updateRecord(record.id.toString(), inputs)
            .then((json) => {
                setRecord(new Record(json.data))
                setIsEditing(false)
                toastSuccess('Record Edited')
            })
            .catch(() => {})
    }

    if (!ability.can('Edit', 'RefundRecord')) {
        return <InsufficientPermissions />
    }

    return <RecordRefundForm handleSubmit={handleSubmit} record={record} />
}
